import { IJxtClassicPicto } from './types';
import {
  ResourceOccupationStatusEnum,
  getHeatmapFill,
  getOccupationFill,
  getStatusFill,
  getSvgProperties,
} from '@jooxter/utils';

const JxtClassicPicto = ({ radius = 30, occupationStatus, x, y, size, status, heatmapIntensity }: IJxtClassicPicto) => {
  const { centerX, centerY, scale, badgeOffset, shouldShowOccupationBadge } = getSvgProperties(
    x,
    y,
    radius,
    size,
    occupationStatus
  );

  const circleFill = heatmapIntensity !== undefined ? getHeatmapFill(heatmapIntensity) : getStatusFill(status);

  return (
    <g>
      <circle cx={centerX} cy={centerY} r={radius} fill={circleFill} strokeWidth={radius / 1.9} />
      {shouldShowOccupationBadge && (
        <>
          <circle
            cx={centerX + badgeOffset}
            cy={centerY - badgeOffset}
            r={radius / 2.3}
            fill={getOccupationFill(occupationStatus)}
            stroke="white"
            strokeWidth={radius / 20}
            data-testid="occupation-badge"
          />

          <path
            d={
              occupationStatus === ResourceOccupationStatusEnum.Occupied
                ? 'M34 9.25C35.3672 9.25 36.5 8.13672 36.5 6.75C36.5 5.38281 35.3672 4.25 34 4.25C32.6133 4.25 31.5 5.38281 31.5 6.75C31.5 8.13672 32.6133 9.25 34 9.25ZM35.7383 9.875H35.4062C34.9766 10.0898 34.5078 10.1875 34 10.1875C33.4922 10.1875 33.0039 10.0898 32.5742 9.875H32.2422C30.7969 9.875 29.625 11.0664 29.625 12.5117V13.3125C29.625 13.8398 30.0352 14.25 30.5625 14.25H37.4375C37.9453 14.25 38.375 13.8398 38.375 13.3125V12.5117C38.375 11.0664 37.1836 9.875 35.7383 9.875Z'
                : 'M34.1561 6C32.9061 6 32.0937 6.51562 31.453 7.4375C31.3437 7.59375 31.3749 7.82812 31.5468 7.9375L32.2187 8.45312C32.3749 8.57812 32.6093 8.54688 32.7343 8.39062C33.1249 7.90625 33.4218 7.625 34.0311 7.625C34.5155 7.625 35.1093 7.92188 35.1093 8.39062C35.1093 8.75 34.8124 8.92188 34.3437 9.1875C33.7811 9.5 33.0468 9.89062 33.0468 10.8594V11C33.0468 11.2188 33.2187 11.375 33.4218 11.375H34.5624C34.7655 11.375 34.9374 11.2188 34.9374 11V10.9219C34.9374 10.25 36.8905 10.2188 36.8905 8.40625C36.8905 7.04688 35.4687 6 34.1561 6ZM33.9999 11.8438C33.3905 11.8438 32.9061 12.3281 32.9061 12.9219C32.9061 13.5156 33.3905 14 33.9999 14C34.5937 14 35.078 13.5156 35.078 12.9219C35.078 12.3281 34.5937 11.8438 33.9999 11.8438Z'
            }
            fill="white"
            transform={`translate(${centerX + badgeOffset}, ${centerY - badgeOffset}) scale(${scale / 1.3}) translate(-34, -10)`}
          />
        </>
      )}
    </g>
  );
};

export default JxtClassicPicto;
